import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonBase } from '@material-ui/core';
import { Spinner } from '../../../../../Components';
import { GetParams, showError } from '../../../../../Helper';
import { AgreementDetailsTable } from './AgreementDetailsTable';
import { GetAllVendorAgreementsAPI } from '../../../../../Services';
import { AgreementDetailsManagementDialog } from './AgreementDetailsManagement/AgreementDetailsManagementDialog';

export const AgreementDetails = ({
  parentTranslationPath,
  contactReletedWithVendorId,
  translationPath,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: 25,
    search: '',
  });
  const [isOpenAddDialog, setIsOpenAddDialog] = useState(false);
  const emptyInitialFetch = useRef(true);

  const [isLoading, setIsLoading] = useState({
    allAgreementDetails: false,
    addAgreementDetails: false,
  });

  const [items, setItems] = useState({
    allAgreementDetails: {
      result: [],
      totalCount: 0,
    },
  });

  const GetAgreementDetailsByVendorId = async (search) => {
    try {
      setIsLoading((item) => ({ ...item, allAgreementDetails: true }));
      const rs = await GetAllVendorAgreementsAPI(+GetParams('id'), {
        pageIndex: filter.pageIndex + 1,
        pageSize: filter.pageSize,
        name: filter.search,
      });

      if (!!rs.totalCount) {
        emptyInitialFetch.current = false;
      }

      setItems((item) => ({
        ...item,
        allAgreementDetails: {
          result: rs?.result,
          totalCount: rs.totalCount,
        },
      }));
    } catch (error) {
      showError(t(`agreement-details-get-failed`));
    } finally {
      setIsLoading((item) => ({ ...item, allAgreementDetails: false }));
    }
  };

  const reloadData = () => {
    GetAgreementDetailsByVendorId();
  };

  useEffect(() => {
    reloadData();
  }, [filter]);

  return (
    <div className='agreement-details-deveoloper-wrapper childs-wrapper d-flex-column'>
      <div className='w-100 agreement-details-add'>
        <Spinner isActive={isLoading.allAgreementDetails} isAbsolute />
        <div className='w-100 mt-2 mb-2'>
          <div className=''>
            <ButtonBase
              className='px-2 MuiButtonBase-root btns theme-solid '
              onClick={() => setIsOpenAddDialog(true)}
            >
              <span className='mdi mdi-plus' />
              {t('add_new_agreement_details')}
            </ButtonBase>
          </div>
        </div>
      </div>
      {!isLoading.allAgreementDetails && emptyInitialFetch.current ? (
        <h2 className='text-center pt-5'>{t('no_agreements')}</h2>
      ) : (
        <AgreementDetailsTable
          parentTranslationPath={parentTranslationPath}
          data={items.allAgreementDetails}
          filter={filter}
          setFilter={setFilter}
          reloadData={reloadData}
          contactReletedWithVendorId={contactReletedWithVendorId}
        />
      )}
      {isOpenAddDialog && (
        <AgreementDetailsManagementDialog
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isOpen={isOpenAddDialog}
          onClose={() => setIsOpenAddDialog(false)}
          onSave={() => {
            setIsOpenAddDialog(false);
            reloadData();
          }}
          reloadData={reloadData}
        />
      )}
    </div>
  );
};
